import frontendDeveloper from "../shared/assets/frontendDeveloper.png";
import backendDeveloper from "../shared/assets/backendDeveloper.png";

export const developersData = [
  {
    id: 1,
    name: {
      uz: "Abdullox Nig'matullayev",
      ru: "Абдуллох Ниг'матуллаев",
      en: "Abdullox Nig'matullayev",
    },
    job: {
      uz: "Frontend dasturchi",
      ru: "Фронтенд разработчик",
      en: "Frontend developer",
    },
    phone: "+998 90 098 64 14",
    email: "country.abu@gmail.com",
    telegram: "@NAbdullokh",
    image: frontendDeveloper,
    website: "abdullox.uz",
    linkedin: "https://www.linkedin.com/in/abdullox-nigmatullayev/",
  },
  {
    id: 2,
    name: {
      uz: "Azizbek Sobitov",
      ru: "Азизбек Собитов",
      en: "Azizbek Sobitov",
    },
    job: {
      uz: "Backend dasturchi",
      ru: "Бэкенд разработчик",
      en: "Backend developer",
    },
    phone: "+998 97 253 80 05",
    email: "asobitovo2005@gmail.com",
    telegram: "@TheBugCreator",
    linkedin: "https://www.linkedin.com/in/azizbek-sobitov/",
    image: backendDeveloper,
  },
];
